export default __webpack_public_path__ + "static/media/checkblack.a5259c87.png";